import type { DummyFoods } from './dummyFoods'

// Reference for dried fruit: https://www.bellaviva.com/dried-fruit
export const driedFruit: DummyFoods = {
  'Dried fruit': {
    Apple: ['Apple chips'],
    Apricots: ['Dried apricots'],
    Banana: ['Banana chips'],
    Blueberries: ['Dried blueberries'],
    Cherries: ['Dried cherries'],
    Cranberries: ['Dried cranberries'],
    Currants: ['Dried currants'],
    Figs: ['Dried figs'],
    Kiwi: ['Dried kiwi'],
    Mango: ['Dried mango'],
    Nectarines: ['Dried nectarines'],
    Oranges: ['Orange chips'],
    Peaches: ['Dried peaches'],
    Pears: ['Dried pears'],
    Persimmons: ['Dried persimmons'],
    Pluots: ['Dried pluots'],
    Prunes: ['Prune'],
    Raisins: ['Raisin'],
    Strawberries: ['Dried strawberries'],
  },
}
